import React, { useRef } from 'react'; 
import { CPP, C, PY, CSS, JS, RCTJS, FLASK, NPM, NODE, HTML, ORACLE, GIT, GITCS, MSSQLS, SQLDEV, NUMPY,
  PANDAS, MATPLOT, SCIKIT, KERAS, SQLALCH, OPGL, SDL, LINUX, WIN, VS, VSCODE, JUPYTER, PUTTY, BASH, AZURE } from './CustomIcon.js';
import CustomHook from './CustomHook';
import '../styles/Skills.css';

const skillData = [
  {
    name: 'Programming Languages',
    des: 'Experience in C++ for high-performance computing and Python for data analysis and automation.',
    icons: [<CPP />, <C />, <PY />],
  },
  {
    name: 'Graphics and Game Development',
    des: 'Experience in using SFML for 2D game development and rendering, and OpenGL with ImGUI for real-time graphics simulations and GPU programming.',
    icons: [<OPGL />, <SDL />],
  },
  {
    name: 'Version Control',
    des: 'Proficient in version control using Git and GitHub for collaborative projects.',
    icons: [<GIT />, <GITCS />],
  },
  {
    name: 'Database',
    des: 'Managed and queried large databases using SQL and PL/SQL with SQL Developer and Toad. Experienced in creating and maintaining efficient packages and functions, optimizing query performance. Worked extensively with Oracle databases.',
    icons: [<ORACLE />, <MSSQLS />, <SQLDEV />],
  },
  {
    name: 'Web Development',
    des: 'Built dynamic websites using JavaScript, HTML, and CSS.',
    icons: [<JS />, <HTML />, <CSS />],
  },
  {
    name: 'Frameworks',
    des: 'Experienced with React for front-end development and Flask for backend APIs.',
    icons: [<RCTJS />, <FLASK />, <NPM />, <NODE />],
  },
  {
    name: 'Libraries',
    des: 'Proficient in scientific libraries for data analysis and visualization.',
    icons: [<NUMPY />, <PANDAS />, <MATPLOT />, <SCIKIT />, <KERAS />, <SQLALCH />],
  },
  {
    name: 'Development Tools',
    des: 'Familiar with various development tools and environments for efficient programming.',
    icons: [<LINUX />, <WIN />, <VS />, <VSCODE />, <JUPYTER />, <PUTTY />, <BASH />, <AZURE />],
  },
];

function Skills() {
  const divs = useRef([]);
  const refTab = useRef();
  CustomHook(refTab, divs);
  
  return (
    <section className='skills' ref={refTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        Skills
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        Versatile in leveraging diverse programming languages, frameworks, and tools to bring ideas to life.
      </div>
      <div className="list">
        {skillData.map((value, key) => (
          <div className='item' key={key} ref={(el) => el && divs.current.push(el)}>
            <div className="icon-container">
              {value.icons.map((icon, index) => (
                <div key={index} className="icon">{icon}</div>
              ))}
            </div>
            <h3>{value.name}</h3>
            <div className="des">{value.des}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
